<template>
  <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app color="primary darken-2" dark>
    <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
      <v-app-bar-nav-icon @click.stop="$emit('update:drawer', !drawer)"></v-app-bar-nav-icon>
      <span class="hidden-sm-and-down">C-TRAX</span>
    </v-toolbar-title>
    <v-text-field
      flat
      solo-inverted
      hide-details
      prepend-inner-icon="mdi-magnify"
      label="Search"
      class="hidden-sm-and-down"
    ></v-text-field>
    <div class="flex-grow-1"></div>
    <v-btn icon>
      <v-icon>mdi-apps</v-icon>
    </v-btn>
    <v-btn icon>
      <v-icon>mdi-bell</v-icon>
    </v-btn>
    <v-btn icon large>
      <v-avatar size="32px" item>
        <v-img src="@/assets/logo.png" alt="Ctrax logo"> </v-img
      ></v-avatar>
    </v-btn>
  </v-app-bar>
</template>
<script>
export default {
  props: {
    drawer: {
      required: true,
    },
  },
};
</script>
